<div class="flex flex-col gap-5 p-5">
  <h1 class="text-primary max-w-full text-xl font-bold break-words">{{ fullName }}</h1>
  <div class="border-b border-gray-200">
    <nav class="-mb-px flex gap-8" aria-label="Tabs">
      <button
        (click)="setActiveTab('info')"
        [ngClass]="
          activeTab() === 'info'
            ? 'border-primary text-primary'
            : 'hover-border-primary hover-text-primary border-transparent text-gray-500'
        "
        class="border-b-2 pb-3 text-sm font-medium transition-colors hover:cursor-pointer"
        i18n="@@tabInfo">
        Info
      </button>
      <button
        (click)="setActiveTab('roles')"
        [ngClass]="
          activeTab() === 'roles'
            ? 'border-primary text-primary'
            : 'hover-border-primary hover-text-primary border-transparent text-gray-500'
        "
        class="border-b-2 pb-3 text-sm font-medium transition-colors hover:cursor-pointer"
        i18n="@@tabRoles">
        Roles
      </button>
      <button
        (click)="setActiveTab('activity-logs')"
        [ngClass]="
          activeTab() === 'activity-logs'
            ? 'border-primary text-primary'
            : 'hover-border-primary hover-text-primary border-transparent text-gray-500'
        "
        class="border-b-2 pb-3 text-sm font-medium transition-colors hover:cursor-pointer"
        i18n="@@tabActivityLogs">
        Activity logs
      </button>
    </nav>
  </div>

  @if (activeTab() === "info") {
    <app-user-info-tab [data]="data()" />
  }

  @if (activeTab() === "roles") {
    <div class="rounded-lg bg-white p-6 shadow-sm">
      <div class="group/roles relative flex flex-wrap items-center gap-1">
        @if (data().roles && data().roles.length > 0) {
          <span
            class="inline-flex w-36 items-center justify-center rounded-md border border-blue-100 bg-blue-50 px-2 py-0.5 text-center text-[10px] font-bold whitespace-nowrap text-blue-700">
            {{ getRoleTitle(data().roles[0]) }}
          </span>
          @if (data().roles.length > 1) {
            <span
              class="inline-flex min-w-[25px] items-center justify-center rounded-md border border-gray-200 bg-gray-100 px-1.5 py-0.5 text-[10px] font-bold text-gray-600">
              +{{ data().roles.length - 1 }}
            </span>
            <div
              class="absolute bottom-full z-[110] mb-2 hidden min-w-[150px] flex-col gap-1 rounded-lg border border-gray-200 bg-white p-2 shadow-xl group-hover/roles:flex">
              @for (role of data().roles; track role.id) {
                <span class="border-b py-0.5 text-[11px] font-semibold text-gray-700 last:border-0">
                  • {{ getRoleTitle(role) }}
                </span>
              }
            </div>
          }
        } @else {
          <p class="text-sm text-gray-400 italic" i18n="@@noRoles">No roles assigned.</p>
        }
      </div>
    </div>
  }

  @if (activeTab() === "activity-logs") {
    <div class="rounded-lg bg-white p-6 shadow-sm">
      <p class="text-sm text-gray-400" i18n="@@noActivityLogs">No activity logs available.</p>
    </div>
  }
</div>
